import React from 'react';
import { BODY } from '../../primitives.js';

const h = React.createElement;

/**
 * Capacity in ten blocks: lime, gold past warnAt, coral at the limit, with the status written.
 *
 * @param {object} p
 * @param {number} p.value
 * @param {number} p.max
 * @param {React.ReactNode} [p.label]
 * @param {React.ReactNode} [p.detail]
 * @param {number} [p.warnAt]
 * @param {number} [p.blocks]
 * @param {React.CSSProperties} [p.style]
 */
export function Meter({ value = 0, max = 10, label, detail, warnAt = .8, blocks = 10, style }) {
  const r = max ? value / max : 0, lit = Math.min(blocks, Math.round(r * blocks));
  const fill = r >= 1 ? 'var(--coral)' : r >= warnAt ? 'var(--gold)' : 'var(--lime)';
  const status = r >= 1 ? 'At limit' : r >= warnAt ? 'Near limit' : null;
  return h('div', { style: { fontFamily: BODY, ...style } },
    (label || detail) ? h('div', { style: { display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 6, fontSize: 12.5 } }, h('span', { style: { fontWeight: 800 } }, label), status ? h('span', { style: { fontSize: 11, fontWeight: 800, color: r >= 1 ? 'var(--coral-tx)' : 'var(--gold-tx)' } }, status) : null, h('span', { style: { marginLeft: 'auto', color: 'var(--mut2)', fontWeight: 600, fontVariantNumeric: 'tabular-nums' } }, detail != null ? detail : `${value} / ${max}`)) : null,
    h('div', { role: 'meter', 'aria-valuenow': value, 'aria-valuemin': 0, 'aria-valuemax': max, 'aria-label': label, style: { display: 'flex', gap: 3 } },
      Array.from({ length: blocks }, (_, i) => h('span', { key: i, className: i < lit ? 'gx-block' : undefined, style: { flex: 1, height: 12, borderRadius: 6, border: '2px solid var(--ink)', background: i < lit ? fill : 'var(--track)', boxSizing: 'border-box', animationDelay: (i * 30) + 'ms' } }))));
}
